import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const PurposeSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default PurposeSVG;
